<template>
  <div>
    <heads ref="isWxApplet" :backs="1" :msg="title_msg" :states="1" :address_management="1"></heads>
    <div class="borders"></div>
    <van-list
            v-show="isShow"
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了1"
            @load="onLoad"
    >
      <div v-for="(item, index) in list" :key="index" class="main" :title="item">
        <div class="main_left">
          <img class="kd_img" :src="item.product_thumb" alt>
        </div>
        <div class="main_right">
          <p class="trade_name">{{ item.product_name }}</p>
          <p
                  class="trade_num"
          >共{{ item.quantity }}件商品 {{ item.express_name?item.express_name:'未知快递' }}</p>
          <button class="see_wl" @click="wl_detail(item.id)">查看物流</button>
          <button class="confirm_receipt" @click="confirm_receipts(item.id)">确认收货</button>
        </div>
      </div>
    </van-list>
    <div v-show="!isShow" class="kongzt">
      <img src="@/assets/new_kong.png" alt>
      <p>您还没有快递哦~</p>
    </div>
    <div v-if="buttonShow">
      <div class="div_empty"></div>
      <van-button round type="danger" class="btn_submit" block @click="go_address_management()">地址管理</van-button>
    </div>
  </div>
</template>

<script>
  import heads from '@/components/common/heads.vue'
  import { express_list, confirm_receipt } from '@/api/my_user.js'
  export default {
    components: {
      heads
    },
    data() {
      return {
        title_msg: '快递',
        list: [],
        loading: false,
        finished: false,
        page: 1,
        total: 0,
        retlen: 0,
        limit: 6,
        isShow: true,
        buttonShow: false // 微信小程序打开,下方显示地址管理按钮
      }
    },
    mounted() {
      if (this.$refs.isWxApplet.wx === true) {
        this.buttonShow = true
      }
      // this.onLoad()
      //   this.get_list()
    },
    destroyed() {
      this.list = []
      this.page = 1
      this.total = 0
    },
    methods: {
      wl_detail(id) {
        this.$router.push({
          path: '/index/express_detail',
          query: {
            id: id
          }
        })
      },
      confirm_receipts(id) {
        var params = {
          id: id
        }
        confirm_receipt(params).then(res => {
          console.log(res)
        })
      },
      // 地址管理跳转地址
      go_address_management() {
        // 快递》》》》地址管理
        this.$router.push({ path: '/index/express/address_management', query: { backs: 1 }})
      },
      onLoad() {
        var params = {
          page: this.page,
          limit: this.limit
        }
        express_list(params).then((res) => {
          if (!res.result.list.length && !this.list.length) {
            this.isShow = false
            return false
          }
          this.list = this.list.concat(res.result.list)
          this.total = res.result.count // 数据总条数
          this.retlen = res.result.list.length // 本次返回数据的长度
          if (this.retlen < this.limit) {
            console.log(321)
            this.finished = true // 数据加载完毕显示 没有更多了
            this.isShow = true
          }
          this.page++
          this.loading = false
          console.log(this.list)
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .kongzt {
    width: 100%;
    img {
      width: 310px;
      height: 310px;
      margin: 0 auto;
      display: block;
      margin-top: 300px;
    }
    p {
      font-size: 30px;
      font-weight: 600;
      color: #999;
      text-align: center;
      padding-top: 30px;
    }
  }

.express_no{
  color: #999;
  position: absolute;
  left: 224px;
  bottom: 18px;
}
.see_wl {
  width: 147px;
  height: 46px;
  background: #fff;
  color: #ee2e2e;
  border: 3px solid #ee2e2e;
  border-radius: 30px;
  position: absolute;
  right: 190px;
  bottom: 18px;
}
.confirm_receipt {
  width: 147px;
  height: 46px;
  color: #ee2e2e;
  background: #fff;
  border: 3px solid #ee2e2e;
  border-radius: 30px;
  position: absolute;
  right: 24px;
  bottom: 18px;
}
.borders {
  background: #e5e5e5;
  width: 100%;
  height: 1px;
}
.main {
  width: 100%;
  height: 197px;
  border-top: 4px solid #f7f7f7;
  // border-bottom: 1px solid #ccc;
  position: relative;
}
.main_left {
  width: 220px;
  float: left;
}
.kd_img {
  width: 160px;
  height: 162px;
  margin: 15px 0 0 27px;
}
.main_right {
  width: 750px;
  height: 197px;
  // position: relative;
  position: relative;
}
.trade_name {
  font-size: 30px;
  color: #333;
  padding-top: 20px;
  letter-spacing: 1px;
}
.trade_num {
  color: #999;
  padding-top: 20px;
  position: absolute;
  // right: 315px;
  left: 220px;
  top: 60px;
}

  .right-bottom{
    height: 52px;
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .express_no{
      color: #999;
    }
    .see_wl {
      width: 147px;
      height: 46px;
      background: #fff;
      color: #ee2e2e;
      border: 3px solid #ee2e2e;
      border-radius: 30px;
      right: 190px;
      bottom: 18px;
      margin-right: 12px;
    }
    .confirm_receipt {
      width: 147px;
      height: 46px;
      color: #ee2e2e;
      background: #fff;
      border: 3px solid #ee2e2e;
      border-radius: 30px;
      margin-right: 20px;
      right: 24px;
    }
  }


  .borders {
    background: #e5e5e5;
    width: 100%;
    height: 1px;
  }
  .main {
    width: 100%;
    border-top: 4px solid #f7f7f7;
    padding: 8px 0px;
    // border-bottom: 1px solid #ccc;
    position: relative;
    display: flex;
    justify-content: start;
  }
  .main_left {
    flex-shrink: 0;
    float: left;
    margin: 15px 15px;
    .kd_img {
      height: 162px;
    }
  }
  .main_right {
    height: 197px;
    // position: relative;
    position: relative;
  }
  .trade_name {
    font-size: 30px;
    color: #333;
    text-align: start;
    padding-top: 12px;
    letter-spacing: 1px;
    text-overflow: ellipsis; //可以用来多行文本的情况下，用省略号“…”隐藏超出范围的文本 。
    overflow : hidden;
    display: -webkit-box;//必须结合的属性 ，将对象作为弹性伸缩盒子模型显示 。
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .trade_num {
    color: #999;
    padding-top: 12px;
    // right: 315px;
    left: 220px;
    top: 60px;
  }

  .div_empty{
    height: 200px;
  }
  .btn_submit{
    width: 80%;
    background: #ff272c;
    position: fixed;
    left: 50%;
    margin-left: -40%;
    margin-bottom: 40px;
    bottom:0;
  }
</style>
